import { useAuthInit } from './hooks/useAuth'
import { BrandingProvider } from './hooks/useBranding'
import { ActiveClassProvider } from './context/ActiveClassContext'
import { ThemeProvider } from './context/ThemeContext'
import { AppRouter } from './router'

/**
 * Root komponen PRADNYA
 * - Inisialisasi auth listener (satu kali)
 * - Provide branding context ke seluruh aplikasi
 * - Provide active class context ke seluruh alur guru
 * - Provide theme context (Dark Linear / Enterprise Slate)
 * - Render router
 */
export default function App() {
  // Inisialisasi auth state dari Firebase
  useAuthInit()

  return (
    <ThemeProvider>
      <BrandingProvider>
        <ActiveClassProvider>
          <AppRouter />
        </ActiveClassProvider>
      </BrandingProvider>
    </ThemeProvider>
  )
}
